import React from 'react';
import { motion } from 'framer-motion';

const clientLogos = [
  "https://imgg.io/images/2025/11/30/08c2c04f2bfe7c58db96ae97937d357b.jpg",
  "https://imgg.io/images/2025/11/30/099d39013d387a2a44b36eb18e0bbce7.jpg",
  "https://imgg.io/images/2025/11/30/a33d88ccfef3cd6a4a8e484bbc3c18a2.jpg",
  "https://imgg.io/images/2025/11/30/f33e6e6ebda7c32595a1d73d0cdb0354.jpg",
  "https://imgg.io/images/2025/11/30/14437d58447c4c4b763d16b152b47b3b.jpg",
  "https://imgg.io/images/2025/11/30/b5f20eccda2443c288f37e729752e7d2.jpg",
  "https://imgg.io/images/2025/11/30/a45639ddd1441e54aee718875ab1bea4.jpg",
  "https://imgg.io/images/2025/11/30/e897fbd6042683c838d1ed4e38d4bf7c.jpg",
  "https://imgg.io/images/2025/11/30/16bc1245078a9c2955fa764329c094b0.jpg",
  "https://imgg.io/images/2025/11/30/892a98ac79c45b9789374ef6b67a7c45.jpg",
  "https://imgg.io/images/2025/11/30/8445f3efc46bfeebd7c65df41dbc46b6.jpg",
  "https://imgg.io/images/2025/11/30/75d243e3aa2b58d2b6c959045bd4dc43.jpg",
  "https://imgg.io/images/2025/11/30/b1879fc89ff7cecf200213c2ccfbeca4.jpg",
  "https://imgg.io/images/2025/11/30/0d2ea837ae43db2db344dec0b3d88365.jpg",
  "https://imgg.io/images/2025/11/30/70504a7dd9db13d680d3611dab6d807a.jpg",
  "https://imgg.io/images/2025/11/30/118d736e762f8b9446cbf0c08ce3d8ec.jpg",
  "https://imgg.io/images/2025/11/30/8010edfc563adf4ab3074f107cbb6a4c.jpg",
  "https://imgg.io/images/2025/11/30/9e0dbc9432456e47cbd0e81d1c963209.jpg",
  "https://imgg.io/images/2025/11/30/127a6fa4ed49376373b867d6b69a0378.jpg",
  "https://imgg.io/images/2025/11/30/782149f0cebf6774b0615b7cdc8a3df7.jpg",
  "https://imgg.io/images/2025/11/30/f5894be6eebc31f90ca9f421de519d8c.jpg",
  "https://imgg.io/images/2025/11/30/840da87e414f4d73870d5b1d447135e2.jpg",
  "https://imgg.io/images/2025/11/30/95eca4ff08a01d67524edb179d75ae2b.jpg",
   "https://imgg.io/images/2025/11/30/08c2c04f2bfe7c58db96ae97937d357b.jpg",
  "https://imgg.io/images/2025/11/30/099d39013d387a2a44b36eb18e0bbce7.jpg",
  "https://imgg.io/images/2025/11/30/a33d88ccfef3cd6a4a8e484bbc3c18a2.jpg",
  "https://imgg.io/images/2025/11/30/f33e6e6ebda7c32595a1d73d0cdb0354.jpg",
  "https://imgg.io/images/2025/11/30/14437d58447c4c4b763d16b152b47b3b.jpg",
  "https://imgg.io/images/2025/11/30/b5f20eccda2443c288f37e729752e7d2.jpg",
  "https://imgg.io/images/2025/11/30/a45639ddd1441e54aee718875ab1bea4.jpg",
  "https://imgg.io/images/2025/11/30/e897fbd6042683c838d1ed4e38d4bf7c.jpg",
  "https://imgg.io/images/2025/11/30/16bc1245078a9c2955fa764329c094b0.jpg",
  "https://imgg.io/images/2025/11/30/892a98ac79c45b9789374ef6b67a7c45.jpg",
  "https://imgg.io/images/2025/11/30/8445f3efc46bfeebd7c65df41dbc46b6.jpg",
  "https://imgg.io/images/2025/11/30/75d243e3aa2b58d2b6c959045bd4dc43.jpg",
  "https://imgg.io/images/2025/11/30/b1879fc89ff7cecf200213c2ccfbeca4.jpg",
  "https://imgg.io/images/2025/11/30/0d2ea837ae43db2db344dec0b3d88365.jpg",
  "https://imgg.io/images/2025/11/30/70504a7dd9db13d680d3611dab6d807a.jpg",
  "https://imgg.io/images/2025/11/30/118d736e762f8b9446cbf0c08ce3d8ec.jpg",
  "https://imgg.io/images/2025/11/30/8010edfc563adf4ab3074f107cbb6a4c.jpg",
  "https://imgg.io/images/2025/11/30/9e0dbc9432456e47cbd0e81d1c963209.jpg",
  "https://imgg.io/images/2025/11/30/127a6fa4ed49376373b867d6b69a0378.jpg",
  "https://imgg.io/images/2025/11/30/782149f0cebf6774b0615b7cdc8a3df7.jpg",
  "https://imgg.io/images/2025/11/30/f5894be6eebc31f90ca9f421de519d8c.jpg",
  "https://imgg.io/images/2025/11/30/840da87e414f4d73870d5b1d447135e2.jpg",
  "https://imgg.io/images/2025/11/30/95eca4ff08a01d67524edb179d75ae2b.jpg"
];

// كررنا اللوقوز 3 مرات لضمان عدم وجود فجوات
const repeatedLogos = [...clientLogos, ...clientLogos, ...clientLogos];

export default function ProductSpecialty() {
  return (
    <motion.section 
    
      initial={{ opacity: 0, y: 100, scale: 0.9 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 1.2, ease: "easeOut", type: "spring", stiffness: 100 }}
      viewport={{ once: true }}
      className="py-16 md:py-24 -mt-10 md:-mt-16 overflow-hidden relative bg-gradient-to-b from-white via-gray-50/50 to-white"
    >
       
      <style jsx>{`
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-33.33%); } /* لأننا كررنا 3 مرات */
        }

        .marquee-track {
          display: flex;
          animation: marquee 40s linear infinite;
        }

        .marquee-track:hover {
          animation-play-state: paused;
        }
      `}</style>
      
      <div className="text-center mb-16 relative px-4">
        <motion.img
          src="/logo192.png"
          alt="ZAN Logo"
          initial={{ opacity: 0, y: -20, scale: 0.85 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          viewport={{ once: true }}
          className="mx-auto mb-5 w-20 md:w-24 opacity-95"
        />

        <motion.h2
          initial={{ opacity: 0, y: 40, filter: 'blur(10px)' }}
          whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
          transition={{ duration: 1.2, ease: 'easeOut' }}
          viewport={{ once: true }}
          className="font-cairo text-4xl md:text-5xl font-bold text-[#141d3c] mb-2"
        >
          عـمـلائنـا
        </motion.h2>

        <motion.h3
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          viewport={{ once: true }}
          className="font-cairo text-lg md:text-2xl text-gray-600 mb-2"
        >
          علامات تجارية اختارت زان
        </motion.h3>

        <motion.h4
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.35 }}
          viewport={{ once: true }}
          className="font-cairo text-sm md:text-lg text-gray-500"
        >
          ثقة تُبنى … ونجاح يستمر
        </motion.h4>

        <motion.div 
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          viewport={{ once: true }}
          className="w-24 h-1 bg-gradient-to-r from-transparent via-[#141d3c] to-transparent mx-auto mt-6"
        />
      </div>

      <motion.div 
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, delay: 0.6, ease: "easeOut" }}
        viewport={{ once: true }}
        className="relative"
      >
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
        
        <div className="overflow-hidden relative w-full">
          <div className="marquee-track">
            {repeatedLogos.map((logo, index) => (
              <div 
                key={index} 
                className="inline-flex items-center justify-center mx-6 md:mx-10 flex-shrink-0"
              >
                <div className="w-20 h-20 md:w-28 md:h-28 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-500 p-3 md:p-4 flex items-center justify-center group hover:scale-110 border border-gray-100">
                  <img 
                    src={logo} 
                    alt={`Client ${index + 1}`}
className="w-full h-full object-contain transition-all duration-500 group-hover:scale-105 group-hover:brightness-110"                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        
      </motion.div>
      <div className="absolute bottom-0 left-0 w-full">
        <div className="h-[4px] bg-gray-500"></div>
      </div>
    </motion.section>
  );
}
